Components.EmptyStateGraphic = {
    bindings: {
        shouldShow: '=?',
        title: '@?',
        subTitle: '@?',
        imgUrl: '@?',
        marginTop: '@?',
        alignTo: '@?'
    },
    // @ngInject
    controller: function EmptyStateGraphic(){

        switch (this.alignTo) {
            case 'center':
                this.textAlign = 'center';
                this.flexAlign = 'center';
                break;
            case 'left':
                this.textAlign = 'left';
                this.flexAlign = 'flex-start';
                break;
            case 'right':
                this.textAlign = 'right';
                this.flexAlign = 'flex-end';
                break;
            default:
                this.textAlign = 'center';
                this.flexAlign = 'center';
        }


        this.customStyles = {
            "margin-top": this.marginTop + 'px' || 0,
            "text-align": this.textAlign,
            "align-items": this.flexAlign
        }
    },
    name: 'hbEmptyStateGraphic',
    templateUrl: 'angular/app/modules/common/ui_components/empty_state_graphic/empty_state_graphic_component.html',
};